<ng-template #headerMatMenu>
    <button *ngIf="showNotifications && !(showDemoModeToggle | async)"
            mat-icon-button disableRipple animated delayed
            [fadeFrom]="'right'"
            [attr.aria-label]="'PayHOA notifications' + (notificationsCount > 0 ? ' (' + notificationsCount + ' unread)' : '')"
            (click)="openNotifications()">
            <mat-icon [matBadgeHidden]="notificationsCount === 0"
                      [matBadge]="notificationsCount > 9 ? '9+' : notificationsCount"
                      [svgIcon]="'v2:fi-br-bell'">
            </mat-icon>
    </button>

    <mat-slide-toggle *ngIf="showDemoModeToggle | async" [formControl]="exitDemoMode">{{ 'Test Mode' }}</mat-slide-toggle>

    <button #appMenuTrigger="matMenuTrigger"
            mat-flat-button disableRipple animated delayed [fadeFrom]="'right'"
            [class.mat-menu-active]="appMenuTrigger.menuOpen"
            [attr.aria-label]="'PayHOA app menu'"
            [matMenuTriggerFor]="appMenu">
        <app-avatar-block [isLoadingInitialData]="loadingProfile"
                          [initials]="profile.initials"
                          [iconOnly]="tabletMode$ | async">
            <span avatarTitle>{{ profile.name }}</span>
            <mat-icon>arrow_drop_down</mat-icon>
        </app-avatar-block>
    </button>
    <mat-menu #appMenu="matMenu" xPosition="before" class="header-menu" [overlapTrigger]="false">
        <app-header-menu-items></app-header-menu-items>
    </mat-menu>
</ng-template>

<ng-container *ngIf="mobileMode$ | async; else headerMatMenu">
    <button mat-flat-button disableRipple animated delayed [fadeFrom]="'right'"
            [attr.aria-label]="'PayHOA app menu'"
            (click)="openMobileHeaderMenu()">
        <app-avatar-block [isLoadingInitialData]="loadingProfile"
                          [initials]="profile.initials"
                          [badge]="notificationsCount"
                          [iconOnly]="tabletMode$ | async">
            <span avatarTitle>{{ profile.name }}</span>
            <mat-icon>arrow_drop_down</mat-icon>
        </app-avatar-block>
    </button>
</ng-container>
